import React from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';
import {useRootStore, useDsManager, useAppState} from '@stores/AppStateContext';

import {UpgradePlanButton} from '../typesOfButtons/UpgradePlanButton';
import {NotificationButton} from '../context-menu/NotificationPanel/NotificationButton';
import {ProfileIcon} from '../RightMenu/ProfileIcon';
import {PAGES} from '@stores/ViewStore';
import {pageAdditionalParamsRef} from '../../../volatile/pageAdditionalParams';
import {screenSizeProvider} from '@stores/ScreenSizeProvider';
import {isFreePlan} from '@stores/client';
import {inviteUser} from '../../../actions/invite';
import {HeaderMenu as HeaderMenuPure} from '../../components/HeaderMenu/HeaderMenu';
import {getPageTitle} from '../../components/HeaderMenu/getPageTitle';

export {getPageTitle} from '../../components/HeaderMenu/getPageTitle';

export const HeaderMenu = observer(() => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const dsManager = useDsManager();
    const isMobile = screenSizeProvider.view !== 'desktop';
    const title = getPageTitle(rootStore.view.page);
    const clientSubscriptionPlan = dsManager?.clientAR?.row?.subscription_plan;
    const shouldShowUpgradeButton = isFreePlan(clientSubscriptionPlan);
    const currentBackCb = pageAdditionalParamsRef.current?.back;

    return (
        <HeaderMenuPure
            title={title}
            isMobile={isMobile}
            hasBack={!!currentBackCb}
            onBack={currentBackCb ?? undefined}
            inviteLabel={intl.get('headerMenu.invite_people').d('Invite people')}
            onInvite={() => inviteUser(dsManager!, appState)}
            upgradeButton={
                shouldShowUpgradeButton
                    ? <UpgradePlanButton contentType={!isMobile ? 'iconWithFullText' : 'icon'} className="hm_button"/>
                    : undefined
            }
            notificationButton={<NotificationButton className="hm_button"/>}
            profileIcon={<ProfileIcon className="hm_button" size={24}/>}
        />
    );
});
